export default function PHP_is_float() {
  return (
    <div>
      <h1>PHP_is_float</h1>
    </div>
  );
}
